import {AdditionalServiceUsage} from "../../../components/additional-service";
import {AdditionalServicesContainer} from "./styled";
import React, {useEffect, useState} from "react";
import {useAppSelector} from "../../../../redux/store";
import SingleAdditionalService from "./single-additional-service";
import {OrderModel} from "../../../shared/models/order/order-item.model";
import {OrderPopupCard, OrderPopupCardTitle} from "../styled";
import BarekamText from "../../../components/text";
import Message from "../../../components/message";
import {MessageSections} from "../../../components/message/message";
import {AdditionalServiceModel} from "../../../shared/models/order/additional-service.model";

export const AdditionalServices = ({order, onSelect, isNewOrder, isReadonly, updateData}: AdditionalServicesProps) => {
    const {additionalServices} = useAppSelector(state => state.staticDataReducer);

    const [visibleServices, setVisibleServices] = useState<AdditionalServiceModel[]>([]);
    const [selectedServices, setSelectedServices] = useState<Set<number>>(new Set());

    useEffect(() => {
        setVisibleServices(additionalServices.filter(service => checkVisibility(service)));
        setSelectedServices(new Set((updateData && updateData.additionalService || order.additionalService)
            .map((service: AdditionalServiceModel) => service.additionalServiceId)));
    }, [order, updateData])

    function checkVisibility(service: AdditionalServiceModel) {
        switch (service.additionalServiceId) {
            case 1: // check_the_package_contents
                return false;
            case 2: // additional_packaging
                return false;
            case 3: // change_receiver
                return false;
            case 4: // divide_package
                return false;
            case 5: // home_delivery
                return false;
            case 6: // on_hold
                // const orderStateId = order?.trackRecord[0]?.state.orderStateId;
                // return orderStateId === 1;
            default:
                return order.additionalService.some(orderService => service.additionalServiceId === orderService.additionalServiceId)
        }
    }

    if (!!visibleServices.length) {
        return (
            <OrderPopupCard>
                <AdditionalServicesContainer>
                    <OrderPopupCardTitle>
                        <BarekamText variant={'m'} bold>
                            <Message messageKey={'additional_services'} sectionId={MessageSections.ORDERS}/>
                        </BarekamText>
                    </OrderPopupCardTitle>

                    {visibleServices.map(service => (
                        checkVisibility(service)
                            ? <SingleAdditionalService service={service}
                                                       usage={AdditionalServiceUsage.EDIT_ORDER}
                                                       order={order}
                                                       updateData={updateData}
                                                       onSelect={onSelect}
                                                       isReadonly={isReadonly}
                                                       isNewOrder={false}
                                                       selected={selectedServices.has(service.additionalServiceId)}
                                                       key={service.additionalServiceId}/>
                            : ''
                    ))}
                </AdditionalServicesContainer>
            </OrderPopupCard>
        )
    } else {
        return <div style={{marginTop: '-1rem'}}/>
    }
}

interface AdditionalServicesProps {
    order: OrderModel;
    onSelect: (updateData: {[key: string]: any}) => void,
    updateData?: {[key: string]: any},
    isNewOrder: boolean;
    isReadonly?: boolean;
}